import colors from './colors'

const fallbackFonts =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"

export default {
  grid: {
    container: '1300px',
    gap: '',
  },
  border: {
    radius: '',
  },
  font: {
    family: `'Myriad Pro', ${fallbackFonts}`,
    familySecondary: `'Etelka Text Pro', ${fallbackFonts}`,
    familyTertiary: `'Caecilia LT Pro', ${fallbackFonts}`,
    light: 300,
    regular: 400,
    semibold: 500,
    bold: 600,
    black: 700,
    heavyblack: 800,
    sizes: {
      xxsmall: '4px',
      xsmall: '8px',
      small: '14px',
      medium: '16px',
      large: '24px',
      xlarge: '32px',
      xxlarge: '48px',
      title: '64px',
    },
  },
  colors,
  spacings: {
    xxsmall: '8px',
    xsmall: '16px',
    small: '24px',
    medium: '32px',
    large: '48px',
    xlarge: '64px',
    xxlarge: '72px',
  },
  layers: {
    base: 10,
    menu: 20,
    overlay: 30,
    fixedMenu: 35,
    modal: 40,
    alwaysOnTop: 50,
  },
  sizes: {
    navbar: '80px',
    fixedNavbar: '168px',
  },
}
